var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItImg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1997 1899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efeff4;}.cls-2{fill:#c6c9d3;}.cls-23,.cls-3{fill:#fff;}.cls-3{opacity:0.26;}.cls-4{fill:#d7d9e0;}.cls-5{fill:#2b69b3;}.cls-6{fill:#18174a;}.cls-7{fill:#888b8f;}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:#e5b731;}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 303.45,
    y1: 610.17,
    x2: 1071.74,
    y2: 610.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1545.04,
    y1: 1677.39,
    x2: 1554.83,
    y2: 1692.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efeff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1850.63,
    y1: 1647.67,
    x2: 1869.68,
    y2: 1659,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -4284.24,
    y1: 1338.81,
    x2: -4235.37,
    y2: 1313.16,
    gradientTransform: "matrix(-1, 0, 0, 1, -2817.23, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1352.03,
    y1: 1273.62,
    x2: 1288.16,
    y2: 1176.78,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1372.85,
    y1: 1259.89,
    x2: 1308.97,
    y2: 1163.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1211.7,
    y1: 1294.32,
    x2: 1144.22,
    y2: 1180.48,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1255.34,
    y1: 1413.7,
    x2: 1632.75,
    y2: 1413.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 362.55,
    y1: 1791.08,
    x2: 371.05,
    y2: 1822.37,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 267.19,
    y1: 1778.53,
    x2: 268.74,
    y2: 1812.14,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 707.62,
    y1: 951.72,
    x2: 861.12,
    y2: 816.76,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 686.3,
    y1: 927.48,
    x2: 839.8,
    y2: 792.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 611.08,
    y1: 998.37,
    x2: 622.42,
    y2: 976.48,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 409.36,
    y1: 1205.77,
    x2: 619.53,
    y2: 1113.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 298.55,
    y1: 1101.58,
    x2: 369.38,
    y2: 1101.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 297.03,
    y1: 966.25,
    x2: 212.81,
    y2: 860.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 274.68,
    y1: 984.04,
    x2: 190.46,
    y2: 878.18,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1819.6,1278.36c-174.72,411.4-640.13,641.86-1043.74,579.69-65.67-10.11-245.72-40.25-405.13-182.41C63.86,1402-1.77,860.08,245.77,478.19c180.17-277.94,503.14-435.5,810-427.62,66.1,1.7,319.44,12.16,542.08,195.74,32.7,27,104.82,91,169.82,192.69C1920.34,677.7,1933.46,1010.25,1819.6,1278.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1248.75,1192.69S1242.91,947.06,1356,881.32s328.25-106.85,336.32-459.56c4.72-206.49,9.83-296.77,13.25-336.13a23.25,23.25,0,0,0-27.46-24.9C1571,80.91,1222.92,164,1149.94,401.58,1063.43,683.24,1248.75,1192.69,1248.75,1192.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1595.29,158.86c-117.62,104.9-253.63,290.55-326.12,476.2-9.3,30.6-36.52,95.66-48.34,211.27-10.56,96.41-5.31,198.3,7.49,265.74a7.86,7.86,0,0,0,9.19,6.25c7.33-1.39,6.35-9.27,6.29-9-14.62-115.23-8.55-258.65,25-388,42.79-158.9,138.25-312.95,237-443.61l10.16-12.86c76.5-98.24,92.6-99,85.45-105.81A4.48,4.48,0,0,0,1595.29,158.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1910.29,557.83c-78.71-14.37-319.27-52.2-390,7.72-84.94,72-85.25,258.82-108.9,407.93-19.59,123.47-55.92,229.44-92,312.32l10.09,3.87c26.55-61.81,51.14-127.77,67.32-180.86C1438,973.61,1485,957,1569.54,939.92s179-80.28,206.71-179.6c21-75.36,101.78-150.14,139.53-181.84A11.81,11.81,0,0,0,1910.29,557.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1799.59,599.8c-100.43,4.21-208.22,50-262.92,136l-5.17,8.2c-11.92,19.22-79.51,155.9-117,269.2a2.69,2.69,0,0,0,1.71,3.4,2.73,2.73,0,0,0,3.37-1.61c26.15-64,63.71-145.15,93.63-205.84,32.08-66.21,54.53-111.06,127.7-154,81.45-46.26,159.26-51,159-51a2.16,2.16,0,0,0-.31-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1137.69,502.8,1122,538.52a30.6,30.6,0,0,0,7.29,34.79l22.76,21a25.62,25.62,0,0,1,7.92,22.31,273.65,273.65,0,0,0-1.24,62.35,25.61,25.61,0,0,1-8.82,22L1126.34,721a30.6,30.6,0,0,0-8.69,34.47l14.19,36.33a30.61,30.61,0,0,0,29.76,19.45l31-1.25a25.64,25.64,0,0,1,21.4,10.19,273.93,273.93,0,0,0,43.17,45,25.62,25.62,0,0,1,9.3,21.77l-2.5,30.86a30.6,30.6,0,0,0,18.23,30.52L1317.89,964a30.62,30.62,0,0,0,34.79-7.29l21-22.76A25.61,25.61,0,0,1,1396,926a272.51,272.51,0,0,0,62.35,1.24,25.62,25.62,0,0,1,22,8.83l20.07,23.61a30.64,30.64,0,0,0,34.48,8.69l36.32-14.19a30.62,30.62,0,0,0,19.45-29.76l-1.25-31a25.62,25.62,0,0,1,10.19-21.4,273.19,273.19,0,0,0,45-43.18,25.61,25.61,0,0,1,21.77-9.29l30.86,2.5a30.62,30.62,0,0,0,30.52-18.23l15.65-35.72a30.62,30.62,0,0,0-7.29-34.8l-22.76-21a25.62,25.62,0,0,1-7.92-22.31,273.55,273.55,0,0,0,1.24-62.34,25.61,25.61,0,0,1,8.82-22l23.61-20.08a30.59,30.59,0,0,0,8.69-34.47l-14.19-36.32a30.64,30.64,0,0,0-29.76-19.46l-31,1.26a25.64,25.64,0,0,1-21.4-10.2,273.48,273.48,0,0,0-43.17-45,25.63,25.63,0,0,1-9.3-21.77l2.5-30.86a30.6,30.6,0,0,0-18.23-30.52l-35.72-15.65a30.6,30.6,0,0,0-34.79,7.28l-21,22.76a25.58,25.58,0,0,1-22.3,7.93,273.65,273.65,0,0,0-62.35-1.24,25.61,25.61,0,0,1-22-8.82L1365,347a30.62,30.62,0,0,0-34.48-8.68l-36.32,14.19a30.6,30.6,0,0,0-19.45,29.75l1.25,31a25.61,25.61,0,0,1-10.2,21.4,273.52,273.52,0,0,0-45,43.18,25.58,25.58,0,0,1-21.77,9.29l-30.86-2.5A30.63,30.63,0,0,0,1137.69,502.8Zm97.39,39c61.61-109.15,200-147.69,309.2-86.08S1692,655.75,1630.35,764.9s-200,147.69-309.2,86.08S1173.46,650.93,1235.08,541.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100,1093.76c28.68-122.41,122.46-218.5,241.84-247.88,82.08-20.21,160.83-9.37,227.39,23.37,22.08,10.86,48.31-1.43,54.43-25.74,58.84-233.84,265.92-406.6,512.36-406.6,292.23,0,529.13,242.9,529.13,542.53,0,7.95-.16,18.82-.29,29.24,1,22.41,10.57,31.92,24.81,34.31,114.5,12.22,204.48,109,209.47,228.36,5.73,137.06-103.06,250.61-236.86,250.61H424.67C212.81,1522,46.93,1320.12,100,1093.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.82,1139.63c25.6-109.29,109.34-195.08,215.93-221.32,73.29-18,143.6-8.36,203,20.87,19.71,9.69,43.14-1.28,48.6-23,52.53-208.79,237.43-363,457.47-363,260.92,0,472.44,216.87,472.44,484.4,0,7.1-.14,16.8-.26,26.11.92,20,9.44,28.5,22.16,30.63,102.23,10.91,182.57,97.32,187,203.9,5.11,122.37-92,223.76-211.49,223.76h-1105C296.57,1522,148.46,1341.75,195.82,1139.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1619.69,908.28a3.28,3.28,0,0,1-3.2-2.57C1569,692.15,1448,588.08,1354.92,538.39c-101-53.9-192-57.32-192.86-57.35a3.29,3.29,0,0,1-3.19-3.38,3.25,3.25,0,0,1,3.39-3.18c.92,0,93.18,3.45,195.48,58a488.58,488.58,0,0,1,154,128.21c52.55,66.26,90,148.22,111.19,243.61a3.29,3.29,0,0,1-2.49,3.92A3.05,3.05,0,0,1,1619.69,908.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M314.58,501.2l-10.22,44.6a35.92,35.92,0,0,0,16,38.51l30.82,19.22a30,30,0,0,1,14,24,320.79,320.79,0,0,0,12.22,72.13,30.06,30.06,0,0,1-5.36,27.29l-22.82,28.31a35.94,35.94,0,0,0-2.48,41.64l24.31,38.76a35.91,35.91,0,0,0,38.56,15.91l35.42-8.22A30.08,30.08,0,0,1,472,850.4a320.87,320.87,0,0,0,59.61,42.41,30,30,0,0,1,15.48,23.06L550.93,952a35.93,35.93,0,0,0,27.7,31.19l44.6,10.23a35.93,35.93,0,0,0,38.51-16L681,946.56a30,30,0,0,1,24-14,320.78,320.78,0,0,0,72.14-12.22,30.07,30.07,0,0,1,27.29,5.35l28.31,22.83A35.9,35.9,0,0,0,874.3,951l38.77-24.3A36,36,0,0,0,929,888.12l-8.22-35.43a30.06,30.06,0,0,1,7.07-26.89,321.08,321.08,0,0,0,42.41-59.62A30,30,0,0,1,993.3,750.7l36.12-3.87a35.92,35.92,0,0,0,31.19-27.69l10.22-44.6a35.9,35.9,0,0,0-16-38.51L1024,616.81a30.06,30.06,0,0,1-14-24,320.22,320.22,0,0,0-12.21-72.13,30,30,0,0,1,5.35-27.29l22.83-28.31a35.94,35.94,0,0,0,2.47-41.64L1004.1,384.7a35.9,35.9,0,0,0-38.55-15.91L930.12,377a30.09,30.09,0,0,1-26.9-7.07,320.54,320.54,0,0,0-59.61-42.41,30.08,30.08,0,0,1-15.48-23.06l-3.87-36.12a35.91,35.91,0,0,0-27.69-31.19L752,226.93a35.94,35.94,0,0,0-38.52,16l-19.21,30.83a30.05,30.05,0,0,1-24,14A321,321,0,0,0,598.12,300a30.07,30.07,0,0,1-27.29-5.35l-28.3-22.83a35.92,35.92,0,0,0-41.64-2.47l-38.77,24.31a35.91,35.91,0,0,0-15.9,38.55l8.22,35.42a30.07,30.07,0,0,1-7.07,26.9A321.13,321.13,0,0,0,405,454.16a30,30,0,0,1-23.06,15.48l-36.12,3.87A35.92,35.92,0,0,0,314.58,501.2Zm120.79,23.63c47.14-139.31,198.27-214,337.57-166.89S987,556.21,939.82,695.51s-198.27,214-337.57,166.89S388.24,664.13,435.37,524.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M777.76,971.29,747,997.6a31.8,31.8,0,0,0-9,35.84l11.77,29.94a26.61,26.61,0,0,1-2.7,24.45,283.44,283.44,0,0,0-29.4,57.73,26.63,26.63,0,0,1-18.22,16.58l-31.18,8.07a31.81,31.81,0,0,0-23.74,28.3l-3.19,40.39a31.82,31.82,0,0,0,19,31.67l29.53,12.86a26.63,26.63,0,0,1,15.39,19.23,283.64,283.64,0,0,0,20,61.63,26.59,26.59,0,0,1-1.18,24.57l-16.32,27.72a31.83,31.83,0,0,0,3.22,36.8l26.31,30.82a31.82,31.82,0,0,0,35.84,9l29.94-11.77a26.61,26.61,0,0,1,24.45,2.7,284.27,284.27,0,0,0,57.74,29.4,26.62,26.62,0,0,1,16.57,18.22l8.07,31.17a31.83,31.83,0,0,0,28.3,23.75l40.39,3.18a31.8,31.8,0,0,0,31.67-19l12.87-29.52a26.57,26.57,0,0,1,19.22-15.39,284.44,284.44,0,0,0,61.64-20,26.6,26.6,0,0,1,24.56,1.17l27.73,16.32a31.79,31.79,0,0,0,36.79-3.22l30.82-26.31a31.79,31.79,0,0,0,8.95-35.83l-11.77-29.94a26.61,26.61,0,0,1,2.7-24.45,284.53,284.53,0,0,0,29.4-57.74,26.62,26.62,0,0,1,18.22-16.57l31.18-8.07a31.83,31.83,0,0,0,23.74-28.3l3.19-40.4a31.82,31.82,0,0,0-19-31.67L1281,1208a26.62,26.62,0,0,1-15.39-19.22,283.72,283.72,0,0,0-20-61.64,26.62,26.62,0,0,1,1.17-24.57l16.33-27.72a31.83,31.83,0,0,0-3.22-36.8l-26.32-30.82a31.82,31.82,0,0,0-35.83-9l-29.94,11.77a26.58,26.58,0,0,1-24.45-2.69A283.81,283.81,0,0,0,1085.58,978,26.61,26.61,0,0,1,1069,959.76l-8.07-31.18a31.82,31.82,0,0,0-28.3-23.74l-40.4-3.19a31.8,31.8,0,0,0-31.66,19l-12.87,29.53a26.62,26.62,0,0,1-19.22,15.39,284.41,284.41,0,0,0-61.64,20,26.54,26.54,0,0,1-24.56-1.17l-27.73-16.32A31.82,31.82,0,0,0,777.76,971.29Zm73.4,80.58c107.07-74.15,254-47.47,328.12,59.6s47.46,254-59.6,328.12-254,47.46-328.12-59.61S744.1,1126,851.16,1051.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1508.08,1730.19c14.92-13,47-23.39,47-23.39l19.29.42c4.89,5.51,7.11,16.18,8.05,22.87-3.63,2.18-10.44,4.09-22.92,4.68A187.74,187.74,0,0,1,1508.08,1730.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1508.08,1730.19a187.74,187.74,0,0,0,51.41,4.58c12.48-.59,19.29-2.5,22.92-4.68.08.54.15,1.06.21,1.54a5.7,5.7,0,0,1-4,6.14c-17.62,5.4-56.38,3.66-71.49,2.72a4,4,0,0,1-2.85-6.48A34.15,34.15,0,0,1,1508.08,1730.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1565.32,1690.56l7.46,15.34a6.27,6.27,0,0,1-4.94,6.13,24.45,24.45,0,0,1-10.81.1,6,6,0,0,1-4.46-5.13l-9.4-16.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1884.15,1693.41c5.61-12.5,4-18.12,15.12-16.88a14.74,14.74,0,0,1,3.39.75,10,10,0,0,1,0,6.51c-2.81,8.08-5,23.76-15.73,37.37a12.21,12.21,0,0,1-9.38,4.57l-12.25.21C1876.91,1716.65,1879.49,1703.78,1884.15,1693.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1864.51,1707.41c9.41-6.63,9.19-35.54,9.19-35.54l14.5-7.38,10.93,7.92a10.13,10.13,0,0,1,3.53,4.87,14.74,14.74,0,0,0-3.39-.75c-11.11-1.24-9.51,4.38-15.12,16.88-4.66,10.37-7.24,23.24-18.86,32.53l-8.43.14a4.52,4.52,0,0,1-3.67-7.27A54.47,54.47,0,0,1,1864.51,1707.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1873.61,1650.87l16.21,13.62a4,4,0,0,1-.88,5.26c-2.8,2.21-7.66,4.67-13.62,2.12l-17.79-9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1884.37,1657.58l-13.31,9.93c-2,1.8-6.76,2-8.92.43-22.06-15.9-231.26-112.06-272.72-127.08l31.64-66.44S1890,1652.45,1884.37,1657.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1459.41,1528.55c24.67-13.24,93.4-24.69,93.4-24.69l79.94-21.65s22,65.48-16.51,77.29-94,6.22-117.36,3.13c0,0,31.16,22.38,68.46,130.79,0,0-12.56.26-22.77,2.65,0,0-83.25-103.62-92-130.35C1446.84,1548.09,1438.78,1539.61,1459.41,1528.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1411.56,1312.65c17.29-1.22,69.83,10.2,69.83,10.2l-27,22.19s-21.26-5.18-35.43-8C1419,1337.09,1384,1314.6,1411.56,1312.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1349.8,1328.35s23.17,21.51,37.25,27.36,22.3,12.2,31-3.38,5.37-32.47-6.27-45.07c0,0-17.87-19.61-27.83-20.12S1349.8,1328.35,1349.8,1328.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1399.52,1309.32l-.73,2.1s-14.7-14.88-20.49-8.37-22.49,34.44-35.45,37.18c-12.49,2.64-23.82-7.61-24.61-17.27a1.19,1.19,0,0,1,1-1.24l1.55-.23a1.19,1.19,0,0,0,.52-2.15,1.19,1.19,0,0,1,.4-2.13c3.89-.87,11-4.43,18.71-17.93,11-19.15,24-29.78,38.29-25.14a1.2,1.2,0,0,0,1.54-1.42c-.39-1.84,0-4.41,3.88-6.69,6.7-4,18.16,2.65,23.92,18.52a1.2,1.2,0,0,0,1.83.59c2.24-1.73,6.87-3.84,8.45,6.41,1.62,10.49-.73,15.53-1.93,17.33a1.19,1.19,0,0,1-1.46.44l-12.27-5.18a1.2,1.2,0,0,0-1.6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1402,1310.76s-15.88-10.68-8.23-16.79,18.15,10.94,16.59,17.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1257.36,1378.73s-13,4.63-15.44-3.13,4.32-28.43,0-31.29-11.63-17.12-9.3-23.65l5.34,5.08s-3.63-12,.36-17.07l10.11,26S1261.88,1365.59,1257.36,1378.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1492.94,1327.1s-23.24-25.64-74,14.37c-35,27.58-161.16,22-161.16,22a61.48,61.48,0,0,1-2.4,15.77s105.86,28.62,185.33,9.19c0,0,87.8,99.53,94.56,119,0,0,57.06,8.53,97.52-25.22,0,0-10.85-33.66-46-72.68C1541.14,1358.86,1492.94,1327.1,1492.94,1327.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1480.74,1378.38a.88.88,0,0,0-.55-1.66c-.3.08-30.23,8.49-35,9.65a.88.88,0,0,0-.63,1.06.86.86,0,0,0,1.05.64c4.75-1.17,34.71-9.58,35-9.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.38,1815.57s-3.23,18.28-4.81,36.39a12.46,12.46,0,0,0,11.93,13.51c24.11,1,75.68,3,94.19,2.14a4.06,4.06,0,0,0,3.57-5.56,9.1,9.1,0,0,0-4.65-4.9L374.42,1818Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M356.73,1804.82l2.6,21.88s14.92,6.94,25.11-.88l-6.18-24.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M358.68,1393.53c-1.12,5.71-6,285.09,23.85,410.29a4.25,4.25,0,0,1-2.49,4.94,74.22,74.22,0,0,1-24.32,5,7.33,7.33,0,0,1-7.27-5.26c-8.53-29-49.44-174.58-54.77-313.61-6-155.35,0-5.29,0-5.29l3.49-96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M261.39,1825.11s-5.15,9.23-10.13,33.77A7.61,7.61,0,0,0,258,1868c8,.78,20.22,1.79,30,1.72a7.59,7.59,0,0,0,7.52-8.46c-1.09-9-4.48-23.65-14.94-35.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M256.87,1797l6.06,33.08s6,4.46,17.86,1.23l-2.89-35.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M240.48,1402.1c-24.42,147.41,5.3,364.32,15.33,406.78a6.61,6.61,0,0,0,5.34,5,44.5,44.5,0,0,0,19.11-.76,6.07,6.07,0,0,0,4.36-5.59c1.34-34.32-1.08-245,21.68-328.31a18.91,18.91,0,0,1,7.3-10.44l44.17-31.4,3.38-50.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M396.12,1122.81c-73.2-1.21-154,19.22-154,19.22-21.82,127.3-3.82,274.14-3.82,274.14,56.67,14.86,120.59-9.09,120.59-9.09,9.42-53.21,53.36-203,53.36-203,35.77-4.44,65.23-14.76,89.49-28.4-18.51-21.45-27.23-48.74-31-64.88C444.88,1118.88,418.69,1123.18,396.12,1122.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M612.32,1015c-7.19-8.68-15.26-5.91-15.26-5.91-10.77,45.5-68.28,83.73-126.3,101.76,3.79,16.14,12.51,43.43,31,64.88C598.07,1121.58,612.32,1015,612.32,1015Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M610.57,1017.2c.76,2.39-8,6-13.09-3.75-.17-4.68-3-24.77-.22-28.59C612.18,964.52,641.1,939,641.1,939a6.88,6.88,0,0,1,.86,9.56l-14,14.62c2.94,5.31,6.52,9.78,8.19,16.2a19.58,19.58,0,0,1-2,14.47,171.79,171.79,0,0,1-9,14.72C619.15,1017.14,610.57,1017.2,610.57,1017.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M621.79,972.69,609,983.53l-4,10.79,11.4,12.65s3.84-21.42,6.69-26.05S624.45,974,621.79,972.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.23,1212.9,242.16,1142s-68.37,46.45-79.61,105.35c12.92.95,36.42,4.31,59.43,15.92C227,1235.49,270.23,1212.9,270.23,1212.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M330,1279.59s-76.76,43.38-102.66,6.34c-5.38-7.69-6.66-15.34-5.34-22.63-23-11.61-46.51-15-59.43-15.92a81.29,81.29,0,0,0,8.83,55.72c45.37,83,168.76-4.59,168.76-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M320.76,1334.47l41.89-146.3a4.26,4.26,0,0,1,3.61-3.07c7.59-.89,29.58-3.37,55-5.52,30.58-2.59,66.1-4.68,87.33-2.9a4.28,4.28,0,0,1,3.5,6.16c-12.07,24.42-61.72,123.76-86.59,156.3a4.24,4.24,0,0,1-3.45,1.69l-97.2-.9A4.28,4.28,0,0,1,320.76,1334.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M425.58,1166.9l30.37-5.06a2.18,2.18,0,0,1,2.43,2.83l-3,9.11a2.21,2.21,0,0,1-1.79,1.48l-29.22,3.9a2.19,2.19,0,0,1-2.42-2.66l1.87-8A2.16,2.16,0,0,1,425.58,1166.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M402.84,1192.61l2.5-13a3,3,0,0,1,2.65-2.43l61.35-6.23a3,3,0,0,1,3.23,3.7l-3.9,16.24a3,3,0,0,1-2.77,2.31l-59.95,3A3,3,0,0,1,402.84,1192.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M330.88,1299.12s-5.84-24-3.48-32.5,6.91-19.46,22.11-17,33.14,8.83,33.14,8.83-.91,11.09-12.46,7.52l7.16,5.54s-1,8.88-10.78,4.14l6.66,7.35s-4.19,7.29-11.37,2.61S351.24,1302,330.88,1299.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M322,1063.38l-23.29,67.35a2.43,2.43,0,0,0,1.1,2.93c6.35,3.51,29.22,13.65,56.79-3.82a11.44,11.44,0,0,0,5.26-8.16l7.54-58.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M372.65,1001s25.57,48.14,22.3,67.59-35,18.05-62.65,2.26l-19.35-52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M333.52,1045.33a2,2,0,0,0,.86-2.9c-2-3.13-5.89-9.52-7.11-15.11,0,0-4.6-3,11.7-6.85s40.61-10,45.71-23.83c5-13.52-8.1-47.54-29-20.44a2,2,0,0,1-3.15,0c-3.42-4.46-12.42-13.71-24.91-8.1-11.69,5.25-13,13.81-12.85,18.13a2,2,0,0,1-2.34,2c-5.91-1.13-20.09-2.09-26.71,12.46-5.46,12-1.91,18.77,1.32,22.09a2,2,0,0,1-.85,3.28c-3.89,1.19-8.9,4.49-8.4,13.59.69,12.58,14.76,11.47,18.77,10.9a2,2,0,0,1,1.76.62c3.43,3.8,18.91,19.94,35.66,21.89a2,2,0,0,0,2.09-2.65l-7.24-21.07a2,2,0,0,1,1.07-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M336.43,1048.32s-18.21-12.49-19.54-2,16.4,15.24,25.18,11.31Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItImg4);
export default __webpack_public_path__ + "static/media/it_img_4.898d4e2a43c63bf3946ccbc19c0063de.svg";
export { ForwardRef as ReactComponent };